import Vue from 'vue';
import VueI18n from 'vue-i18n';

// 引入语言文件
import en from './en.json';
import zh from './zh.json';

Vue.use(VueI18n);

// 检测浏览器语言
const browserLang = navigator.language || navigator.userLanguage;
const defaultLang = browserLang.includes('zh') ? 'zh' : 'en';

// 创建i18n实例
const i18n = new VueI18n({
  locale: localStorage.getItem('lang') || defaultLang,
  fallbackLocale: 'en',
  messages: {
    en,
    zh
  }
});

// 导出i18n实例
export default i18n;